import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {IContextMenuItem} from '@mintdata/mint-kit/impl/components/contextMenu/ContextMenu';
import * as classnames from 'classnames/bind';
import * as React from 'react';

const styles = require('./TopMenu.less');
const cx = classnames.bind(styles);

export abstract class HelpMenuItems
{
    public static build():IContextMenuItem[]
    {
        return [
            {
                label: 'Help Center',
                handler: () => this._showHelpCenter()
            },
            {
                isSeparator: true
            },
            {
                label: 'What is MINTDATA™?',
                handler: () => this._openInNewTab('https://mintdata.com/docs/learn/')
            },
            {
                label: 'The interface',
                handler: () => this._openInNewTab('https://mintdata.com/docs/learn/user-guide/the-interface/')
            },
            {
                label: 'Concepts',
                handler: () => this._openInNewTab('https://mintdata.com/docs/learn/user-guide/concepts/')
            },
            {
                label: 'Work with data',
                handler: () => this._openInNewTab('https://mintdata.com/docs/learn/user-guide/work-with-data/')
            },
            {
                isSeparator: true
            },
            {
                label: 'Components',
                handler: () => this._openInNewTab('https://mintdata.com/docs/reference/components/')
            },
            {
                label: 'Functions',
                handler: () => this._openInNewTab('https://mintdata.com/docs/reference/functions/')
            },
            {
                label: 'Blocks',
                handler: () => this._openInNewTab('https://mintdata.com/docs/reference/blocks/')
            },
            {
                isSeparator: true
            },
            {
                label: 'Data types',
                handler: () => this._openInNewTab('https://mintdata.com/docs/reference/datatypes/')
            },
            {
                label: 'Glossary',
                handler: () => this._openInNewTab('https://mintdata.com/docs/reference/terms/')
            }
        ];
    }

    private static _openInNewTab(url)
    {
        const win = window.open(url, '_blank');

        win.focus();
    }

    private static _showHelpCenter():void
    {
        const {lx} = controllers.ui;

        lx.showLxFrame();
    }
}
